import { Env } from 'auth-common/shared';
import { initializeApp } from 'firebase/app';
import { connectAuthEmulator, getAuth, signInWithCustomToken } from 'firebase/auth';

const firebaseConfig = {
  apiKey: Env.Var.FirebaseAuth.ApiKey,
  authDomain: Env.Var.FirebaseAuth.AuthDomain,
  projectId: Env.Var.FirebaseAuth.ProjectId,
  storageBucket: Env.Var.FirebaseAuth.StorageBucket,
  messagingSenderId: Env.Var.FirebaseAuth.MessagingSenderId,
  appId: Env.Var.FirebaseAuth.AppId,
};

const app = initializeApp(firebaseConfig);
console.log('@@@ firebase auth: initializeAuth');
export const firebaseAuth = getAuth(app);

if (Env.IsDev) {
  connectAuthEmulator(firebaseAuth, 'http://localhost:9099', { disableWarnings: true });
}

// Tauri デスクトップアプリの WebView から signInWithCustomToken を呼び出すためにグローバルに公開。
// Custom Token は有効なトークンがないと使えないため、Web 環境で公開しても安全。
if (typeof window !== 'undefined') {
  // biome-ignore lint/suspicious/noExplicitAny: グローバルに公開するため
  (window as any).__firebaseAuth = firebaseAuth;
  // biome-ignore lint/suspicious/noExplicitAny: グローバルに公開するため
  (window as any).__firebaseSignInWithCustomToken = signInWithCustomToken;
}
